import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { getOne, update } from '../../../common/v4/BackendProvider';
import { EditPage, EditPageTextField, EditPageCheckbox, EditPagePanel } from './../../../common/EditPage';
import { useNavigate, useParams } from 'react-router-dom';

const SmsMasterCodeEdit = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [defaultCurrency, setDefaultCurrency] = useState({});
    const { code_id } = useParams();
    useEffect(() => {
        getOne('/admin/products/sms_master_codes/', code_id).then(response => {
            setData(response.data.data);
        });
    }, [code_id]);

    const handleSave = () => {
        update('/admin/products/sms_master_codes/', code_id, {data: data}).then(response => {
            toast.success("SMS Master Code updated successfully", {});
            navigate('/products/sms_master_codes');
        }).catch(error => {
            toast.error("Error updating SMS Master Code: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate('/products/sms_master_codes');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title={`Update SMS Master Code (${data.ATRNAME})`} >
                <EditPagePanel>
                    <EditPageTextField label="Name" id="ATRNAME" onChange={ onChange } value={ data.ATRNAME } />
                    <EditPageTextField label="ISO Code" id="ATRISOCOUNTRY" onChange={ onChange } value={ data.ATRISOCOUNTRY } />
                    <EditPageCheckbox label="Status" id="ATRSTATUS" onChange={ onChange } value={ data.ATRSTATUS } />
                </EditPagePanel>
            </EditPage>
        </div>
    )
}

export default SmsMasterCodeEdit;